module.exports = __webpack_public_path__ + "img/Ideen_Patriot.4a0d3a1d.png";